import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchFeed, sortFeedData, updateSortFilter, updateGmtOffset, updateOddsFormat, updateCurrency, toggleSettings } from './state/actions';
import moment from 'moment';
import './style.css';
import { isoPad, toFractional, toMoneyLine } from './helpers';
import { SortDropdown, TimezoneDropdown, OddsFormatDropdown, CurrencyDropdown, Loader } from './components';
import { literals } from './constants';


class App extends Component {

  constructor(props){
    super(props);
    this.state = {
      'initialLoad':true
    }
  }

  componentDidMount(){
    this.poll();
    this.setState({
      'initialLoad':false
    })
  }

  poll = () => {
    //fetch every minute //
    this.props._fetchFeed('', this.props.clientId, this.props.productId);
    setTimeout(()=>{
      this.poll();
    }, 36000);
  }

  handleSortChange = (e) => {
    let data = this.props.feedData.slice();
    this.props._updateSortFilter(e.target.value);
    this.sortByValue(data, e.target.value);
  }

  handleTimezoneChange = (e) => {
    this.props._updateGmtOffset(e.target.value);
    localStorage.setItem('betfair_app_prefered_offset', e.target.value);
  }

  handleOddsFormatChange = (e) => {
    this.props._updateOddsFormat(e.target.value);
    localStorage.setItem('betfair_app_prefered_odds_format', e.target.value);
  }

  handleCurrencyChange = (e) => {
    this.props._updateCurrency(e.target.value);
    localStorage.setItem('betfair_app_currency', e.target.value);
  }

  handleTeamsClick = (slug) => {
    if (slug) {
      window.open(`${this.props.feedDomainUrl}${slug}`, '_blank');
    }
  }

  handleSettingsToggler = () => {
    this.props._toggleSettings(this.props.isSettingsOpen);
  }

  formatOdds = (odd_value) => {
    const number_odd_value = parseFloat(odd_value.replace(',', '.'));
    
    switch (this.props.oddsFormat) {
      case 'mon':
        return toMoneyLine(number_odd_value);
      case 'fra':
        return toFractional(number_odd_value);
      default:
        return odd_value;
    }
  }

  sortByValue = (data, filter) => {
    let sorted = data.slice();
    sorted = data.sort((a,b)=>{
      switch (filter) {
        case 'timestamp' :
          return b.timestamp - a.timestamp 
        case '1x2' :
          return  ( b.odds[0].book !== undefined && b.odds[0].book.odd_s !== undefined ? b.odds[0].book.odd_s : 0 ) -  (a.odds[0].book !== undefined && a.odds[0].book.odd_s !== undefined ? a.odds[0].book.odd_s : 0 )
        case '1m':
          return ( b.odds[0].book !== undefined ? b.odds[0].book.odd_1m : 0 ) - ( a.odds[0].book !== undefined ? a.odds[0].book.odd_1m : 0 )
        case '2m':
          return ( b.odds[0].book !== undefined ? b.odds[0].book.odd_2m : 0 ) - ( a.odds[0].book !== undefined ? a.odds[0].book.odd_2m : 0 )
        case 'Xm':
          return ( b.odds[0].book !== undefined ? b.odds[0].book.odd_Xm : 0 ) - ( a.odds[0].book !== undefined ? a.odds[0].book.odd_Xm : 0 )
        case '1':
          return ( b.odds[0].book !== undefined ? b.odds[0].book.odd_1 : 0 ) - ( a.odds[0].book !== undefined ? a.odds[0].book.odd_1 : 0 )
        case 'X':
          return ( b.odds[0].book !== undefined ? b.odds[0].book.odd_X : 0 ) - ( a.odds[0].book !== undefined ? a.odds[0].book.odd_X : 0 )
        case '2':
          return ( b.odds[0].book !== undefined ? b.odds[0].book.odd_2 : 0 ) - ( a.odds[0].book !== undefined ? a.odds[0].book.odd_2 : 0 )
        case 'ou':
          return ( b.odds[1].book !== undefined ? b.odds[1].book.odd_s : 0 ) - ( a.odds[1].book !== undefined ? a.odds[1].book.odd_s : 0 )
        case 'um': 
          return ( b.odds[1].book !== undefined ? b.odds[1].book.odd_u25m : 0 ) - ( a.odds[1].book !== undefined ? a.odds[1].book.odd_u25m : 0 )
        case 'om': 
          return ( b.odds[1].book !== undefined ? b.odds[1].book.odd_o25m : 0 ) - ( a.odds[1].book !== undefined ? a.odds[1].book.odd_o25m : 0 )
        case 'u': 
          return ( b.odds[1].book !== undefined ? b.odds[1].book.odd_u25 : 0 ) - ( a.odds[1].book !== undefined ? a.odds[1].book.odd_u25 : 0 )
        case 'o': 
          return ( b.odds[1].book !== undefined ? b.odds[1].book.odd_o25 : 0 ) - ( a.odds[1].book !== undefined ? a.odds[1].book.odd_o25 : 0 )
        default :
          return b.timestamp - a.timestamp 
      }
    });
    this.props._sortFeedData(sorted);
  }


  renderOddCell = (key, odd_value, odd_perc, odd_money, odd_f) => {
    let formatedOddValue = this.formatOdds(parseFloat(odd_value, 10).toFixed(2).toString().replace('.', ','));
    return(
      <td className="odd-cell" key={key}>
        <div className="odd-cell__inner">
          <div className="odd-cell__inner--numbers">
            <span className="odd-cell__value bluegray-bg">
              {(odd_value !== undefined ? formatedOddValue : '-')}
              {(odd_f !== undefined ? <i className={`odd-${odd_f}`}></i> : '')}
            </span>
            <div className="odd-cell__perc gray-bg">{(odd_perc !== undefined ? `${odd_perc.toString().replace('.', ',')} %` : '-' )}</div>
          </div>
          <div className="odd-cell__money bluelight-bg">
            {(odd_money !== undefined ? `${Math.round(this.applyCurrency(odd_money)).toLocaleString('el')} ${this.props.currencySymbols[this.props.currency]}` : '-')}
          </div>
        </div>
      </td>
    );
  }

  renderOddCellMobile = (rootClass, label, odd_value, odd_perc, odd_money, odd_f) => {
    let formatedOddValue = this.formatOdds(parseFloat(odd_value, 10).toFixed(2).toString().replace('.', ','));
    return(
      <div className={rootClass}>
        <label className="tziroi-mobile__label">{label}</label>
        <div className="odd-cell">
          <div className="odd-cell__numbers">
            <span className="odd-cell__value bluegray-bg">
              {(odd_f !== undefined ? <i className={`odd-${odd_f}`}></i> : '')}
              {(odd_value !== undefined ? formatedOddValue : '-')}
            </span>
            <div className="odd-cell__perc gray-bg">{(odd_perc !== undefined ? `${odd_perc.toString().replace('.', ',')} %` : '-' )}</div>
          </div>
          <div className="odd-cell__money bluelight-bg">
            {(odd_money !== undefined ? `${Math.round(this.applyCurrency(odd_money)).toLocaleString('el')} ${this.props.currencySymbols[this.props.currency]}` : '-')}
          </div>
        </div>
      </div>
    );
  }

  applyCurrency = (value) => {
    switch (this.props.currency){
      case 'GBP':
        return this.props.rates['GBP'] * value;
      case 'USD':
        return this.props.rates['USD'] * value;
      default:
        return value;
    }
  }

  renderTzirosCell = (key, value) => {
    return (
      <td className="darkblue-bg tziros-cell" key={key}>
        <span>
          {value ? `${Math.round(this.applyCurrency(value)).toLocaleString('el')} ${this.props.currencySymbols[this.props.currency]}` : '-'}
        </span>
      </td>
    );
  }

  renderTzirosCellMobile = (label, value) => {
    return (
      <div className="tziroi-mobile__tziros"> {value ? `${label}: ${Math.round(this.applyCurrency(value)).toLocaleString('el')} ${this.props.currencySymbols[this.props.currency]}` : '-'}</div>
    );
  }

  renderTable = (data) => {
    const COMPS_CDN = this.props.COMPS_CDN;
    const TEAMS_CDN = this.props.TEAMS_CDN;
    const FLAGS_EXT = '.png';
    if ( (this.props.isLoading || !data.length ) && this.state.initialLoad ) return <Loader />;
    return (
      <div>
      <table className="tziroi-table">
        <thead>
          <tr>
            <th className="gray-bg comp-cell"><span>{literals.comp[this.props.locale]}</span></th>
            <th className="darkblue-bg time-cell"><span>{literals.startTime[this.props.locale]}</span></th>
            <th className="gray-bg tziros-cell"><span>{literals.match[this.props.locale]}</span></th>
            <th className="bluegray-bg odd-cell--th"><span>1</span></th>
            <th className="bluegray-bg odd-cell--th"><span>Χ</span></th>
            <th className="bluegray-bg odd-cell--th"><span>2</span></th>
            <th className="darkblue-bg tziros-cell"><span>{literals.tziros[this.props.locale]}</span></th>
            <th className="bluegray-bg odd-cell--th"><span>UNDER 2.5</span></th>
            <th className="bluegray-bg odd-cell--th"><span>OVER 2.5</span></th>
            <th className="darkblue-bg tziros-cell"><span>{literals.tziros[this.props.locale]}</span></th>
          </tr>
        </thead>
        
        <tbody>
        {
          data.map((key, i)=>
            <tr key={`row-${i}`}>
              <td className="comp-cell">
                <img alt={key.image_name} src={COMPS_CDN + "svg/4x3/" + key.image_name + ".svg"} />
                <span>{key.comp_name}</span>
              </td>
              <td className="darkblue-bg time-cell" key={`time${i}`}>{moment((key.timestamp+this.props.feedOffset)*1000).utcOffset(isoPad(this.props.gmtOffset) + ":00").format('HH:mm')}</td>
              <td title={key.slug !== undefined && key.slug !== "" ? literals.readPreview[this.props.locale] : ''} onClick={()=>{this.handleTeamsClick(key.slug)}} className={"gray-bg teams-cell " + ((key.slug !== undefined && key.slug !== "") ? 'teams-cell--has-slug' : '')} key={`teams${i}`}>
                <div>
                  <img alt="" className="flag" src={TEAMS_CDN + key.homeTeamId + FLAGS_EXT} />
                  <span>{key.homeTeamName}</span>
                </div>
                <div>
                  <img alt="" className="flag" src={TEAMS_CDN + key.awayTeamId + FLAGS_EXT} />
                  <span>{key.awayTeamName}</span>
                </div>
              </td>
              {this.renderOddCell(
                `odds1${i}`,
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_1 : '', 
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_1p : '', 
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_1m : '',
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_1f : '')}

              {this.renderOddCell(
                `oddsX${i}`,
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_X : '', 
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_Xp : '', 
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_Xm : '',
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_Xf : '')}

              {this.renderOddCell(
                `odds2${i}`,
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_2 : '', 
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_2p : '', 
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_2m : '',
                (key.odds[0].book !== undefined) ? key.odds[0].book.odd_2f : '')}

              {
                this.renderTzirosCell(`tziros1${i}`, key.odds[0].book !== undefined ? key.odds[0].book.odd_s : '')
              }

              {this.renderOddCell(
                `under${i}`,
                (key.odds[1].book !== undefined) ? key.odds[1].book.odd_u25 : '', 
                (key.odds[1].book !== undefined) ? key.odds[1].book.odd_u25p : '', 
                (key.odds[1].book !== undefined) ? key.odds[1].book.odd_u25m : '',
                (key.odds[1].book !== undefined) ? key.odds[1].book.odd_u25f : '')}

              {this.renderOddCell(
                `over${i}`,
                (key.odds[1].book !== undefined) ? key.odds[1].book.odd_o25 : '', 
                (key.odds[1].book !== undefined) ? key.odds[1].book.odd_o25p : '', 
                (key.odds[1].book !== undefined) ? key.odds[1].book.odd_o25m : '',
                (key.odds[1].book !== undefined) ? key.odds[1].book.odd_o25f : '')}

              {
                this.renderTzirosCell(`tziros2${i}`, key.odds[1].book !== undefined ? key.odds[1].book.odd_s : '')
              }
            </tr>
          )
        }
        </tbody>
      </table>
      </div>
    );
  }


  renderMobileTable = (data) => {
    const COMPS_CDN = this.props.COMPS_CDN;
    const TEAMS_CDN = this.props.TEAMS_CDN;
    const FLAGS_EXT = '.png';

    if ( this.props.isLoading || !data.length ) return <Loader />;

    return(
      <div className="tziroi-mobile">
        {
          data.map((key, i)=>
            <div className="tziroi-mobile__item" key={`match-${i}`}>
              <header onClick={()=>{this.handleTeamsClick(key.slug)}} className={"tziroi-mobile__header " + (key.slug ? 'tziroi-mobile__header--has-slug' : '')}>
                <figure className="tziroi-mobile__comp">
                  <img alt={key.image_name} src={COMPS_CDN + "svg/4x3/" + key.image_name + ".svg"} />
                  <span>{key.comp_name}</span>
                </figure>
                <div className="tziroi-mobile__teams">
                  <div className="home">
                    <span title={key.homeTeamName}>{key.homeTeamName}</span>
                    <img title={key.homeTeamName} alt="" className="flag" src={TEAMS_CDN + key.homeTeamId + FLAGS_EXT} />
                  </div>
                  <span className="tziroi-mobile__time">{moment((key.timestamp+this.props.feedOffset)*1000).utcOffset(isoPad(this.props.gmtOffset) + ":00").format('HH:mm')}</span>
                  <div className="away">
                    <img title={key.awayTeamName} alt="" className="flag" src={TEAMS_CDN + key.awayTeamId + FLAGS_EXT} />
                    <span title={key.awayTeamName}>{key.awayTeamName}</span>
                  </div>
                </div>
              </header>
              <div className="tziroi-mobile__body">
                <div className="tziroi-mobile__1x2">
                  {this.renderOddCellMobile(
                    'tziroi-mobile__1', 
                    '1',
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_1 : '', 
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_1p : '', 
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_1m : '',
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_1f : '')}

                  {this.renderOddCellMobile(
                    'tziroi-mobile__x', 
                    'X',
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_X : '', 
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_Xp : '', 
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_Xm : '',
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_Xf : '')}

                  {this.renderOddCellMobile(
                    'tziroi-mobile__2', 
                    '2',
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_2 : '', 
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_2p : '', 
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_2m : '',
                    (key.odds[0].book !== undefined) ? key.odds[0].book.odd_2f : '')}

                
                  {
                    this.renderTzirosCellMobile(`${literals.tziros[this.props.locale]} 1Χ2`, key.odds[0].book !== undefined ? key.odds[0].book.odd_s : '' )
                  }
                </div>

                <div className="tziroi-mobile__ou">

                  {this.renderOddCellMobile(
                    'tziroi-mobile__under', 
                    'UNDER 2.5',
                    (key.odds[1].book !== undefined) ? key.odds[1].book.odd_u25 : '', 
                    (key.odds[1].book !== undefined) ? key.odds[1].book.odd_u25p : '', 
                    (key.odds[1].book !== undefined) ? key.odds[1].book.odd_u25m : '',
                    (key.odds[1].book !== undefined) ? key.odds[1].book.odd_u25f : '')}

                  {this.renderOddCellMobile(
                    'tziroi-mobile__over', 
                    'OVER 2.5',
                    (key.odds[1].book !== undefined) ? key.odds[1].book.odd_o25 : '', 
                    (key.odds[1].book !== undefined) ? key.odds[1].book.odd_o25p : '', 
                    (key.odds[1].book !== undefined) ? key.odds[1].book.odd_o25m : '',
                    (key.odds[1].book !== undefined) ? key.odds[1].book.odd_o25f : '')}
                    
                  {
                    this.renderTzirosCellMobile(`${literals.tziros[this.props.locale]} OVER/UNDER`, key.odds[1].book !== undefined ? key.odds[1].book.odd_s : '')
                  }
                </div>
              </div>
            </div>
          )
        }
      </div>
    );
  }

  renderTextlink = (textlink) => {
    if (textlink === undefined || textlink === "" || !textlink) return;
    return (
      <div className="betfair-app-textlink" dangerouslySetInnerHTML={{__html: textlink}}>
      </div>
    );
  }


  render() {
    this.sortByValue(this.props.feedData, this.props.sortFilter);
    return (
      <div>
        <div className="filters-container">
          <SortDropdown locale={this.props.locale} handleSortChange={this.handleSortChange} />
          <div className={"settings-box " + (this.props.isSettingsOpen ? 'settings-box--open' : '')}>
            <div onClick={this.handleSettingsToggler} className="settings-box__button"><i className="fa fa-cog" aria-hidden="true"></i></div>
            <div className="settings-box__inner">
              <TimezoneDropdown locale={this.props.locale} handleTimezoneChange={this.handleTimezoneChange} defaultValue={this.props.gmtOffset} />
              <OddsFormatDropdown locale={this.props.locale} handleOddsFormatChange={this.handleOddsFormatChange} defaultValue={this.props.oddsFormat} />
              <CurrencyDropdown locale={this.props.locale} defaultValue={this.props.currency} handleCurrencyChange = {this.handleCurrencyChange} />
            </div>
          </div>
     
        </div>
        { 
          (window.innerWidth > 867)
            ? this.renderTable(this.props.feedData)
            : this.renderMobileTable(this.props.feedData)
        }
        {this.props.clientDisabled ? <div className="cors-message">{literals.corsMessage[this.props.locale]}</div> : ''}
        {this.renderTextlink(this.props.textlink)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.isLoading,
    isSettingsOpen: state.isSettingsOpen,
    feedData: state.feedData,
    TEAMS_CDN: state.TEAMS_CDN,
    COMPS_CDN: state.COMPS_CDN,
    FLAGS_EXT: state.FLAGS_EXT,
    sortFilter: state.sortFilter,
    gmtOffset: state.gmtOffset,
    oddsFormat: state.oddsFormat,
    currency: state.currency,
    rates: state.rates,
    feedOffset: state.feedOffset,
    feedDomainUrl: state.feedDomainUrl,
    currencySymbols: state.currencySymbols,
    locale: state.locale,
    textlink:state.textlink,
    clientDisabled:state.clientDisabled
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    _fetchFeed : (url, clientId, productId) => dispatch(fetchFeed(url, clientId, productId)),
    _sortFeedData: (data) => dispatch(sortFeedData(data)),
    _updateSortFilter: (filter) => dispatch(updateSortFilter(filter)),
    _updateGmtOffset: (offset) => dispatch(updateGmtOffset(offset)),
    _updateOddsFormat: (oddsFormat) => dispatch(updateOddsFormat(oddsFormat)),
    _updateCurrency : (currency) => dispatch(updateCurrency(currency)),
    _toggleSettings: (isSettingsOpen) => dispatch(toggleSettings(isSettingsOpen))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/App.js